/**
 * @module admin/dashboards/design/components/page-filter/store
 *
 * Vuex module for admin/dashboards/design/components/page-filter
 */
export * from './state';
export * from './actions';
export * from './mutations';
export * from './getters';

export const namespaced = true;
